<div>
  <div class="fw-bold">Plus ou moins values</div>
  <div class="grid-container ms-5">
    <div
      *ngFor="let addedReducedValue of appraisal.addedReducedValues"
      class="grid-row"
    >
      <div class="description">
        {{ addedReducedValue.description }}
      </div>

      <div class="value-percentage">
        <span *ngIf="addedReducedValue.value >= 0">
          +{{
            addedReducedValue.value
              | currency: "EUR" : "symbol" : "1.0-0" : "fr-FR"
          }}
        </span>
        <span *ngIf="addedReducedValue.value < 0">
          {{
            addedReducedValue.value
              | currency: "EUR" : "symbol" : "1.0-0" : "fr-FR"
          }}
        </span>

        <p-percentage-label
          [percentage]="addedReducedValue.percentage"
        ></p-percentage-label>
      </div>
    </div>
  </div>
</div>
